import { useEffect, useRef, useState } from "react";

/**
 * Tiny on-screen FPS counter (updates twice a second). Colour-coded:
 * green ≥50, amber 30–49, red <30 — so it's obvious at a glance whether a
 * tablet is keeping up. Toggle via Settings → "Show FPS".
 */
export function FpsMeter() {
  const [fps, setFps] = useState(0);
  const rafRef = useRef(0);

  useEffect(() => {
    let frames = 0;
    let last = performance.now();
    const loop = () => {
      rafRef.current = requestAnimationFrame(loop);
      frames++;
      const now = performance.now();
      if (now - last >= 500) {
        setFps(Math.round((frames * 1000) / (now - last)));
        frames = 0;
        last = now;
      }
    };
    rafRef.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  const tone = fps >= 50 ? "good" : fps >= 30 ? "ok" : "bad";
  return <div className={`fps-meter fps-${tone}`} aria-hidden>{fps} FPS</div>;
}
